import PropTypes from "prop-types";

export default {
  totalBalance: PropTypes.number,
  spentAmount: PropTypes.number,
  href: PropTypes.string,
  linkTitle: PropTypes.string,
  isShowingButton: PropTypes.bool,
  onClick: PropTypes.func,
  isSaving: PropTypes.bool,
  items: PropTypes.array,
  currency: PropTypes.string,
  walletName: PropTypes.string,
  totalPrefix: PropTypes.string,
  buttonText: PropTypes.string,
  subtext: PropTypes.string,
  balanceRatio: PropTypes.number,
  remainingText: PropTypes.string,
  remainingBalance: PropTypes.number,
  donutChartPrefix: PropTypes.string,
  donutChartTotalPrefix: PropTypes.string,
};



// WEBPACK FOOTER //
// ./components/employee/shop/walletProps.js